<template>
  <div>
    <div class="account-detail">
      <div class="max-width">
        <iframe :src="pdf_url+'#toolbar=0'" style="width: 100%;height: 400px; border: 2px solid #F19700;" >
        Oops! an error has occurred.
        </iframe>
        <div class="button-group">
          <button class="btn download-btn" @click="viewPdf">DOWNLOAD</button>
          <!-- <button class="btn save-btn">SHARE</button> -->
           <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="share_button" v-bind="attrs" v-on="on">
                    SHARE
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <WhatsApp :url="share_report_url" scale="1.6"></WhatsApp>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Telegram :url="share_report_url" scale="1.6"></Telegram>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Email :url="share_report_url" scale="1.6"></Email>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
        </div>
        <button class="will-button1" @click="uploadInKeepSafe" :disabled="disable">UPLOAD IN KEEPSAFE</button>
        <p><b>Note: </b>Your WILL document is password protected. The password is your PAN number.</p>
      </div>
      <div class="hor-line"></div>
      <div class="max-width">
        <h2>I want to</h2>
        <div class="button-group">
          <button class="btn cancle-btn">NOTARIZE</button>
          <button class="btn save-btn" @click="registerCreation">REGISTER</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { WhatsApp, Telegram, Email } from 'vue-socialmedia-share';
export default {
  components:{
      WhatsApp,
      Telegram,
      Email
  },
  data: () => ({
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
    pdf_url:'',
    disable:true,
    share_report_url:'',
  }),
  mounted(){
      this.$loading(true);
      this.will_id = this.$route.params.will_id;
      this.member_id = this.$route.params.member_id;

      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("will_id", this.will_id);
      formdata.append("member_id", this.member_id);
      axios
        .post(process.env.VUE_APP_ROOT_API + "generate-will-pdf", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.disable = false;
          this.pdf_url = response.data;
          this.shareLink();
        });
        
  },
  methods:{
    registerCreation(){
      this.$router.push({ name: 'RegisterWill'}).catch(() => {});
    },
    viewPdf(){
        window.open(this.pdf_url, '_blank');
    },
    uploadInKeepSafe(){
      let formdata = {
        aws_cognito_id:atob(localStorage.getItem("cognito_idp")),
        will_id:this.$route.params.will_id,
        member_id:this.$route.params.member_id,
        pdf_url:this.pdf_url
      }
      axios
        .post(process.env.VUE_APP_ROOT_API + "uploadInKeepSafe", formdata)
        .then((response) => {
          swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success"
          });
          this.$router.push({ name: 'MyWillKeepSafe'}).catch(() => {});
        })
        .catch(function (error) {});
    },
    shareLink(){
      this.share_report_url = this.pdf_url;
      return this.share_report_url;
    },
  }
}
</script>